import { useState } from 'react';
import type { AnySignableDecision } from '@mls-wallet/shared-types';

export function usePendingSignaturesState() {
  const [pendingSignableIds, setPendingSignableIds] = useState<string[]>([]);
  const [pendingDecision, setPendingDecision] =
    useState<AnySignableDecision | null>(null);
  const [isPendingModalOpen, setIsPendingModalOpen] = useState(false);

  const resetPendingState = () => {
    setPendingSignableIds([]);
    setPendingDecision(null);
    setIsPendingModalOpen(false);
  };

  return {
    pendingSignableIds,
    setPendingSignableIds,
    pendingDecision,
    setPendingDecision,
    isPendingModalOpen,
    setIsPendingModalOpen,
    resetPendingState,
  };
}
